import React from 'react';
import { Link } from 'react-router-dom';

const PRESETS = {
  diamond:    { bg: 'var(--diamond-bg)',    border: 'var(--diamond-border)',    icon: 'var(--diamond-icon)' },
  colorstone: { bg: 'var(--color-stones-bg)', border: 'var(--color-stones-border)', icon: 'var(--color-stones-icon)' },
  pearl:      { bg: 'var(--pearls-bg)',     border: 'var(--pearls-border)',     icon: 'var(--pearls-icon)' },
  jewellery:  { bg: 'var(--jewellery-bg)',  border: 'var(--jewellery-border)',  icon: 'var(--jewellery-icon)' },
  goldsmith:  { bg: 'var(--goldsmith-bg)',  border: 'var(--goldsmith-border)',  icon: 'var(--goldsmith-icon)' },
  gold:       { bg: 'var(--gold-bg)',       border: 'var(--gold-border)',       icon: 'var(--gold-icon)' },
};

export default function ModuleTile({ palette = 'diamond', icon: Icon, title, subtitle, stats, to, testid, comingSoon }) {
  const c = PRESETS[palette] || PRESETS.diamond;
  const content = (
    <div
      data-testid={testid}
      className={`module-tile relative ${comingSoon ? 'opacity-70 cursor-default' : ''}`}
      style={{ background: c.bg, borderColor: c.border, borderWidth: 1, borderStyle: 'solid' }}
    >
      <div className="p-5 md:p-6">
        <div className="flex items-start justify-between gap-3">
          <div className="w-11 h-11 rounded-xl bg-white/70 flex items-center justify-center" style={{ color: c.icon }}>
            {Icon ? <Icon size={22} strokeWidth={1.6} /> : null}
          </div>
          {comingSoon && (
            <span className="text-[10px] uppercase tracking-wider bg-white/70 text-slate-600 rounded-full px-2 py-0.5">Coming Soon</span>
          )}
        </div>
        <div className="mt-4">
          <div className="text-[15px] md:text-base font-medium text-[var(--ink-navy)]">{title}</div>
          {subtitle && <div className="text-xs text-slate-600 mt-0.5">{subtitle}</div>}
        </div>
        {stats && (
          /* Wave 3.31 — Stat boxes now stack the label ABOVE the value
             (instead of left/right) so the value gets the FULL tile width
             to render. This prevents truncation on small laptops (1024-1279px)
             where 3 tiles share the row and inner space is tight.
             ``module-stat-value`` allows word-break for the rare crore
             outlier that still wouldn't fit on a single line. */
          <div className="mt-4 flex flex-col gap-2 text-[11px]">
            {stats.map((s, i) => (
              <div key={i} className="bg-white/70 rounded-md px-3 py-2 min-w-0 flex flex-col gap-0.5">
                <div className="text-slate-500 text-[10px] uppercase tracking-wider">{s.label}</div>
                <div
                  className="font-mono tabular-nums text-[15px] leading-tight text-[var(--ink-navy)] module-stat-value min-w-0"
                  title={typeof s.value === 'string' ? s.value : String(s.value)}
                >
                  {s.value}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
  if (comingSoon || !to) return content;
  return <Link to={to} className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold-accent)] rounded-[14px]">{content}</Link>;
}
